/**
 * `asChild` for Base UI parts (ADR-0088 D3).
 *
 * Call sites written against Radix compose a part with their own element as
 * `<Trigger asChild><Button …/></Trigger>`. Base UI expresses the same thing
 * as `<Trigger render={<Button …/>} />`. The overlay wrappers accept both, so
 * Admin's call sites stay as they were and Student's keep `render`.
 *
 * With `asChild`, the single child element becomes the `render` element and
 * keeps its own children. Base UI merges the child's props over the part's,
 * so the child's `disabled`, handlers and attributes win, as with Radix's
 * Slot. Classes are concatenated, not merged: a part used with `asChild`
 * should carry no classes of its own.
 */
import { isValidElement } from 'react';
/** The `render` and `children` props a Base UI part takes for `asChild`. */
export function asChildProps({ asChild, children, }) {
    if (asChild && isValidElement(children))
        return { render: children };
    return { children };
}
//# sourceMappingURL=as-child.js.map